<template lang='pug'>
.tw-flex.tw-white-card.mb-5.tw-content-center.tw-justify-between.tw-p-10(
	v-if="selectedCarnet < 0 || serviceId == selectedCarnet"
	class="emd:tw-flex-col emd:tw-gap-1 emd:tw-items-center"
)

	.tw-flex.tw-items-center(class="tw-basis-1/4")
		template(v-for="(train_data, ii) in trainClassification" :key="ii")
			img(v-if="trainTypeMap[train_data.value]" :src="trainTypeMap[train_data.value]")
			span(v-if="trainClassification.length > 1 && ii < (trainClassification.length -1)") /

	.ma-0.pl-0.text-h6.font-weight-medium.tw-flex.tw-items-center.tw-justify-center(class="tw-basis-1/4") {{carnetSolution.display_name}}

	div.text-center.tw-flex.tw-items-center.tw-justify-center(class="tw-basis-1/4")
		template(v-for="(serviceData, ii) in serviceClassification" :key="ii")
			small(v-if="catalogServices.length > 0") {{catalogServices[serviceData.catalogServiceId].display_name}}
			small(v-else) {{serviceData.value}}
			small(v-if="trainClassification.length > 1 && ii < (trainClassification.length -1)") &nbsp; / &nbsp;

	div.tw-flex.tw-items-center.tw-justify-end(class="tw-basis-1/4 emd:tw-mt-5")
		v-btn.text-right(
			v-if=" Object.keys(priceList).length > 0"
			elevation="0"
			color="primary-darken-1"
			@click="emit('getAvailability', serviceId)"
			:disabled="!selectedCarnet || bookingStore.isEvaluatedValid"
			:loading="props.loading"
		)
			span.tw-text-xl.tw-text-bold {{formattedPrice}}
			v-icon.tw-ml-10( v-if="selectedCarnet < 0" icon="mdi-cart-arrow-down" )
		//v-btn.text-right.w-100(elevation="0" color="success" @click="cancel" v-else-if="bookingStore.isEvaluatedValid && serviceId == selectedCarnet") Aggiungi al carrello
</template>

<script setup>
import { useBookingStore } from '@/stores/booking';
import {computed, inject} from 'vue';
import * as constants from '@/common-scripts/constants';
import {printCurrencyValue} from "@/common-scripts/utilities";


const trainTypeMap = constants.trainTypeMap;
const bookingStore = useBookingStore();
const props = defineProps({
	carnetSolution: Object,
	priceList: Object,
	trainClassification: Array,
	catalogServices: {
		type: Array,
		default: []
	},
	serviceClassification: Array,
	serviceId: Number,
	selectedCarnet: Number,
	loading: Boolean
});
const {carnetSolution} = props;
const emit = defineEmits(['getAvailability', 'cancelSelection']);
const axios = inject('axios');
const formattedPrice = computed(() => {
	return printCurrencyValue(props.priceList[props.serviceId].totalMoneyPrice.amount, props.priceList[props.serviceId].totalMoneyPrice.currency);
});
</script>

<style scoped lang="scss">
img {
  height: 0.65rem;
  margin-right: 3px;
}

.card-solutions{
	small{
		font-size: 12px;
		line-height: 12px;
		margin: 0;
		padding: 0;
	}
	.v-card__title > div {
		line-height: normal;
		width: 20%;
	}
}

.card-solutions .v-card__text {
  color: #000000;
  font-size: 1.25rem;
  font-weight: 500;
}

/*.card-solutions .v-card__text > .row:first-child > .col {*/
/*  padding-bottom: 0;*/
/*}*/
/**/
/*.card-solutions .v-card__text > .row:last-child > .col {*/
/*  padding-top: 0;*/
/*}*/

.card-solutions .v-card__text > div > span:not(.prezzo) {
  color: #80CBC4;
}

.prezzo {
  cursor: pointer;
}

.prezzo > span {
  color: #E53935;
  font-weight: 600;
}

.solution-message {
  background-color: #FFE0B2;
  color: #E65100;
}

.v-card--disabled {
	background-color: #f2f2f2;
}

.mdi.mdi-cart-off {
	font-size: 35px;
	margin-right: 20%;
}
</style>
